import Vue from "vue";
import Vuex from "vuex";
import viewport from "@stores/viewport";
import theme from "@stores/theme";
import page from "@stores/page";
import locale from "@stores/locale";
import auth from "@stores/auth";

Vue.use(Vuex);

export default new Vuex.Store({
   strict: process.env.NODE_ENV !== "production",
   state: {},
   mutations: {},
   actions: {},
   modules: {
      viewport,
      theme,
      page,
      locale,
      auth,
   },
});
